/*
 * File: array-helper.ts
 * File Created: 2024-02-19 09:26:32
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-05-06 06:56:23
 * Modified By: Val Liu
 * -----
 */

export class ArrayHelper {
    // export function findDiff<T extends { id: unknown }>(
    static findDiff<T extends any>(
        source: T[] | undefined,
        target: T[] | undefined,
        comparer: (a: T, b: T) => boolean,
    ): { removed: any[] | null; remain: any[] | null; inserted: T[] | null } {
        const safeSource = source ?? [];
        const safeTarget = target ?? [];

        const removed: any[] = safeSource.filter(
            (s) => !safeTarget.some((t) => comparer(s, t)),
        );
        const remain: any[] = safeSource.filter((s) =>
            safeTarget.some((t) => comparer(s, t)),
        );
        const inserted: any[] = safeTarget.filter(
            (t) => !safeSource.some((s) => comparer(t, s)),
        );

        return {
            removed: removed.length === 0 ? null : removed,
            remain: remain.length === 0 ? null : remain,
            inserted: inserted.length === 0 ? null : inserted,
        };
    }

    static aggregate<T extends object>(
        source: T[],
        obj: T,
        aggregator: { (obj: T, target: T, final: any): any },
    ): any {
        const result = source.reduce((final, value) => {
            return aggregator(obj, value, final);
        }, {});

        return Object.assign(obj, result);
    }
}
